export default "__VITE_ASSET__G5W0uXtp__"